<template>
  <div>
    <TitlePage :title="$t('edit')+' '+$t('field')"></TitlePage>

    <v-layout wrap>

      <v-flex md9 class="pt-4">
        <v-row>
          <v-flex md3 class="pl-4 pr-4" v-if="getUser.super_admin">
            <CenterAutocomplete
                v-if="this.center_name != null" @message="setCenterId"
                :model="{_id:this.item.center_id, desc:this.center_name}" :items="[{_id:this.item.center_id, desc:this.center_name}]">
            </CenterAutocomplete>
          </v-flex>
          <v-flex md9 class="pl-4 pr-4">
            <SportsAutocomplete @message="setSport" :model="this.item.sports" v-if="this.item.sports != null"></SportsAutocomplete>
          </v-flex>

          <v-flex md6 class="pl-4 pr-4">
            <v-text-field :label="$t('name')" v-model="item.name" :rules="validation.textRules" :error-messages="errors.name" @change="makeSlug" @input="makeSlug"></v-text-field>
          </v-flex>

          <v-flex md6 class="pl-4 pr-4">
            <v-text-field :label="$t('slug')" v-model="item.slug" :rules="validation.textRules" :error-messages="errors.slug"></v-text-field>
          </v-flex>

          <v-flex md12 class="pl-4 pr-4">
            <FeaturesAutocomplete @message="setFeatures" :model="this.item.features" v-if="this.item.features != null"></FeaturesAutocomplete>
          </v-flex>

          <v-flex md3 class="pl-4 pr-4">
            <v-file-input counter show-size truncate-length="15" :label="$t('uploadImage')" v-model="item.file"></v-file-input>
          </v-flex>

          <v-flex md3 class="pl-4 pr-4">
            <v-switch v-model="item.active" inset :label="$t('status')" dense hide-details></v-switch>
          </v-flex>

        </v-row>
      </v-flex>
      <v-flex md3 class="pr-4 pl-4">
        <v-img :src="this.item.image"></v-img>
      </v-flex>


      <v-flex md12 class="pa-4">
        <CKEditor v-if="this.item.note != null" :content="item.note" @message="(data) => item.note = data"></CKEditor>
      </v-flex>

      <v-flex md12 class="pt-10 d-flex">
        <v-divider class="marg-title"></v-divider>
      </v-flex>
      <v-flex md12 class="pt-5 d-flex buttons-group-mobile">
        <v-btn elevation="2" color="" class="mr-auto" @click="$router.go(-1)">
          <v-icon left>mdi-keyboard-backspace</v-icon>
          {{ $t('back') }}
        </v-btn>
        <v-btn elevation="2" color="primary" class="ml-auto" @click="update" type="submit">
          {{ $t('save') }}
          <v-icon right>mdi-content-save</v-icon>
        </v-btn>
      </v-flex>

    </v-layout>
  </div>
</template>

<script>
import TitlePage from "@/components/utils/TitlePage";
import {mapGetters, mapMutations, mapActions} from 'vuex';
import CenterAutocomplete from "@/components/admin/CenterAutocomplete";
import SportsAutocomplete from "@/components/admin/SportsAutocomplete";
import FeaturesAutocomplete from "@/components/admin/FeaturesAutocomplete";
const slugify = require('slugify')
import CKEditor from "@/components/admin/CKEditor";

export default {
  name: "EditField",
  components: {CenterAutocomplete,SportsAutocomplete,FeaturesAutocomplete,TitlePage, CKEditor},
  computed:{
    ...mapGetters({
      'getUser':'user/getUser'
    })
  },
  data() {
    return {
      item: {
        name: '',
        slug: '',
        center_id: null,
        sports: null,
        features:null,
        active: false,
        image: "",
        file: null,
        note: null
      },
      center_name: null,
      check: true,
      errors:{
        name: '',
        slug: '',
        center_id: '',
        sport_id: '',
      },
      validation: {
        textRules: [
          v => !!v || this.$t('fillMandatory'),
        ]
      }
    };
  },
  async created(){
    this.setLoading(true);
    var fetchItem = await this.editItem(this.$route.params)

    this.item.name = fetchItem.result.name;
    this.item.slug = fetchItem.result.slug;
    if(fetchItem.result && fetchItem.result.center_id){
      this.item.center_id = fetchItem.result.center_id;
      this.center_name = fetchItem.result.center.name
    }else {
      this.center_name = ''
    }
    this.item.sports = fetchItem.result.sports;
    this.item.features = fetchItem.result.features;
    this.item.active = fetchItem.result.active;
    this.item.image = fetchItem.result.image;
    this.item.note = (fetchItem.result.note) ? fetchItem.result.note : '';

    this.setLoading(false);
  },
  methods: {
    ...mapMutations({
      'setLoading': 'settings/setLoading',
      'setNotification': 'settings/setNotification',
    }),
    ...mapActions({
      'editItem':'fields/edit',
      'updateItem':'fields/update',
    }),
    async update(){

      await this.checkItem()
      if(!this.check){
        return
      }else {
        await this.resetError()
      }

      await this.setLoading(true);
      var result = await this.updateItem({...this.$route.params, item:this.item})
      await this.setLoading(false);

      if(result.success){

        this.setNotification({
          active: true,
          color: 'success',
          mode: 'multi-line',
          text: this.$t('updateSuccess')
        })

      }else {

        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: result
        })

      }


    },

    async checkItem(){

      this.check = true

      if(!this.item.name){
        this.check = false
        this.errors.name = this.$t('fillMandatory');
      }

      if(!this.item.slug){
        this.check = false
        this.errors.slug = this.$t('fillMandatory');
      }

      if(this.item.sports.length == 0){
        this.check = false
        this.errors.sport_id = this.$t('fillMandatory');
      }

    },

    async makeSlug(){
      this.item.slug = slugify(this.item.name, {remove: /[*+~.()'"!:@,/]/g,lower: true, locale: 'it'})
    },

    async resetError(){
      this.errors = {
        name: '',
        slug: '',
        center_id: '',
        sport_id: '',
      }
    },

    async setCenterId(id){
      this.item.center_id = id
    },
    async setSport(sport){
      this.item.sports = []
      sport.map((x) =>{
        this.item.sports.push(x._id)
      })
    },

    async setFeatures(data){
      this.item.features = []
      data.map((x) =>{
        this.item.features.push(x._id)
      })
    },

  },
  mounted() {

  },
}
</script>

<style scoped>

</style>